import React from "react";
import "./Footer.css";
import logo1 from "./../../images/nasif.jpg";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="conatiner text-center top">
          <div className="flogo text-center">
            <img src={logo1} alt="Nasif Jihan" />
          </div>
          <h4>Nasif Jihan</h4>
          <p>© 2021. All rights reserved by Nasif Jihan.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
